import { IStringDict } from "@src/Stores/Values/types";

export class Location {
  type: number = 0;
  licencePlate: string = "";
  imoNumber: string = "";
  mmsiNumber: string = "";
  globalId: string = "";
  description: string = "";
  name: string = "";
  state: number = 0;
  id: string = "00000000-0000-0000-0000-000000000000";
  timeString: Date = new Date();
  readOnly: boolean = true;
  routeId: string = "";
  locationPositions: LocationPosition[] = [];
  metaData: MetaData[] = null;
  primary: boolean = false;
  isVirtual: boolean = false;
  timeZone: string = "";
  isLocationDeploymentVariablesDownloaded: boolean = false;
}

export class MetaData {
  type: number = 0;
  name: string = "";
  value: string = "";
  dropdownTypeOptions: string[] = [];
  isNew: boolean = false;
}

export class LocationPosition {
  constructor(positionId: string, state: number) {
    this.positionId = positionId;
    this.state = state;
  }
  id?: string = "00000000-0000-0000-0000-000000000000";
  positionId?: string = "00000000-0000-0000-0000-000000000000";
  state?: number = 0;
}

export interface LocationShortWithKey extends LocationShort {
  key: number;  
}

export interface LocationShort {
  type: number;
  description: string;
  name: string;
  id: string;
  icon?: any;
  primary: boolean;
}

export interface LocationGeneral {
  type: number;
  licencePlate: string;
  imoNumber: string;
  mmsiNumber: string;
  globalId: string;
  description: string;
  name: string;
  id: string;
  routeId: string;
  metaData: IStringDict[];
  primary: boolean;
}
